// import React from 'react'
import './MonthlySalaryReport.css'
import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { initializePendingAttendance,  getAuditLog } from '../../../utils/calculateDaysInMonthUtils';
import { getStates, fetchMonths, getDistrict, getProjects, getPendingAttendance, verifyAttendanceBulk } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';
const MonthlySalaryReport = () => {
    const navigate = useNavigate();
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [salaryData, setSalaryData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);


    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        month: false,
        year: false,
    });
    const [errors, setErrors] = useState({});
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const yearInputRef = useRef(null);
    const isFetchDataEnabled = state && district && month && year;
    const [selected, setSelected] = useState('');


    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);




    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);

    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`);
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null);
            setSalaryData([]);
            setHasFetched(false); // Reset fetch status
        }
    }, [state]);

    // Clear salary data and fetch status when any dropdown changes
    useEffect(() => {
        const fetchProjects = async () => {
            try {
                //  const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects`);
                const data = await getProjects();
                setProjectResponse(
                    data.map(pro => ({
                        value: pro.id,
                        label: pro.projectCode,
                    }))
                );
            } catch (error) {
                console.error('Error fetching projects:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
            }
        };
        if (!effectRan.current) {
            fetchProjects();
        }
        return () => {
            effectRan.current = true;
        }
    }, [state, district, year]);


    // Clear salary data and fetch status when any dropdown changes
    useEffect(() => {
        setSalaryData([]);
        setOriginalData([]);
        setHasFetched(false);
    }, [state, district, month, year, project]); // ✅ Add project to depende


    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setProject(null); // ✅ Clear project when state changes
                break;
            case 'district':
                setDistrict(value);
                setProject(null); // ✅ Clear project when district changes
                break;
            case 'month':
                setMonth(value);
                break;
            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };


    const handleYearChange = (date) => {
        const newYear = date ? date.getFullYear() : null;
        setYear(newYear);
        setMonth(null);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        if (!district) newErrors.district = 'District is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const data = await getPendingAttendance({
                stateId:state,
                districtId: district,
                month,
                year,
                projectId: project,
            });

            console.log("API response:", data);

            setHasFetched(true);
            setOriginalData(data);

            const initializedData = initializePendingAttendance(data, month, year);

            setSalaryData(initializedData);

            if (initializedData.length === 0) {
                alert("No employees found for the selected criteria.");
            } else {
                alert("salary data fetched successfully!");
            }
        } catch (error) {
            console.error("Error fetching salary data:", error);
            setErrors((prev) => ({
                ...prev,
                general: "Failed to fetch salary data",
            }));
            setHasFetched(true);
            alert("Failed to fetch salary data. Please try again.");
        }
    };



    const handleClear = () => {
        setDistrict('');
        setState('');
        setMonth('');
        setYear('');
        setProject('');
        setSelected('');
    }

    const gotoDashboard = () => {
        navigate('/dashboard');
    };


    const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);

    return (
        <div className="monthly-salary-container">
            <div className="monthly-salary-box">
                <h2 className="monthly-salary-heading">Salary Report</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="monthly-salary-maincontainer">
                        <div className="monthly-salary-container-part">
                            <div className={`monthly-salary-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="monthly-salary-container-part">
                            <div className={`monthly-salary-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>District </label>
                                {errors.district && <div className="error-message">{errors.district}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="monthly-salary-maincontainer">
                        <div className="monthly-salary-container-part">
                            <div className={`monthly-salary-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="monthly-salary-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}
                                />
                                <label> <span className="required">*</span>Year </label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>
                        <div className="monthly-salary-container-part">
                            <div className={`monthly-salary-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>Month </label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="monthly-salary-maincontainer">

                        <div className="monthly-salary-container-part">
                            <div className={`monthly-salary-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={projectResponse}
                                    value={projectResponse.find(opt => opt.value === project) || null}
                                    onChange={option => handleInputChange(option, 'project')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>Project </label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div>
                        </div>
                        <div className="monthly-salary-container-part">

                        </div>
                    </div>
                    <div className="monthly-salary-btn-div">
                        <button
                            type="submit"
                            className="monthly-salary-btn"
                            disabled={!isFetchDataEnabled}
                        >
                            Fetch Data
                        </button>
                    </div>
                </form>
            </div>
            {hasFetched && (
                <div className="salary-table-container">
                    <table className="salary-table">
                        <thead>
                            <tr>
                                <th>S. No.</th>
                                <th>Employee Id</th>
                                <th>Employee Name</th>
                                <th>Designation</th>
                                <th>District Name</th>
                                <th>Project </th>
                                <th>Contact</th>
                                <th>GrossSalary</th>
                                <th>Basic</th>
                                <th>HRA</th>
                                <th>Convency</th>
                                <th>OtherAllowance</th>
                            </tr>
                        </thead>
                        <tbody>
                            {salaryData.length === 0 ? (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: 'center', padding: '10px' }}>No data available</td>
                                </tr>
                            ) : (
                                salaryData.map((row, index) => {

                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{row.employeeId || 'N/A'}</td>
                                            <td>{row.fullName || 'N/A'}</td>
                                            <td>{row.designation || 'N/A'}</td>
                                            <td>{row.location || 'N/A'}</td>
                                            <td>{row.d}</td>
                                            <td>{row.presentDays}</td>
                                            <td>{row.casualLeave}</td>
                                            <td>{row.daysAbsent || 0}</td>
                                            <td>{ }</td>
                                            <td>{ }</td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                    

                </div>
            )}
        </div>
    );
};

export default MonthlySalaryReport;